import React from 'react'
import {parseHostname} from '@ta-interaktiv/parse-hostname'

import Masthead from '@ta-interaktiv/react-polymorphic-masthead'
import Profile from '../../components/profile'
import Answer from '../../components/answer'
import Question from '../../components/question'
import FeedbackMessage from '@ta-interaktiv/react-feedback-message'
import Tracking from '@ta-interaktiv/react-polymorphic-tracking'
import StandaloneShareButtons from '@ta-interaktiv/react-polymorphic-share-buttons'
import CopyrightNotice from 'ta-react-polymorphic-copyright-notice'

import Waypoint from 'react-waypoint'

import 'ta-semantic-ui/semantic/dist/components/reset.css'
import 'ta-semantic-ui/semantic/dist/components/site.css'
import 'ta-semantic-ui/semantic/dist/components/segment.css'
import 'ta-semantic-ui/semantic/dist/components/header.css'
import 'ta-semantic-ui/semantic/dist/components/container.css'
import 'ta-semantic-ui/semantic/dist/components/divider.css'
import 'ta-semantic-ui/semantic/dist/components/image.css'
import 'ta-semantic-ui/semantic/dist/components/button.css'
import 'ta-semantic-ui/semantic/dist/components/table.css'
import 'ta-semantic-ui/semantic/dist/components/item.css'
import 'ta-semantic-ui/semantic/dist/components/card.css'
import 'ta-semantic-ui/semantic/dist/components/icon.css'
import 'ta-semantic-ui/semantic/dist/components/list.css'
import 'ta-semantic-ui/semantic/dist/components/rail.css'

import 'styles/App.css'

export default class AppComponent extends React.Component {
  constructor (props) {
    super(props)

    this.domain = parseHostname().publicationDomain
  }

  render () {
    return (
      <div className='index'>

        <Masthead inverted articleID='27362773' additionalFacebookShares={17} />

        <header className='ui inverted block vertical segment desktop-only' style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,1)), url(${require(
            './header.jpg')})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '100vh'
        }}>

          <div className='ui container'>
            <div className='header block'>
              <div className='ui container'>
                <h1 className='ui huge white header'>
                Die Könizer Präsidiumsanwärter auf dem Prüfstand
                </h1>
                <p className='ta lead'>Kurz vor dem zweiten Wahlgang nimmt der «Bund» die drei Kandidierenden fürs Könizer Gemeindepräsidium unter die Lupe. Welches Verständnis von Führung haben sie? Und was denken sie über ihre Gegner?
                </p>
              </div>
            </div>

          </div>
        </header>

        <header className='ui inverted block vertical segment mobile-only' style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0.3), rgba(0,0,0,0.5), rgba(0,0,0,0.6)), url(${require(
            './header_mobile.jpg')})`,
          backgroundPosition: 'center',
          backgroundSize: 'cover',
          height: '100vh'
        }}>

          <div className='ui container'>
            <div className='header block'>
              <div className='ui container'>
                <h1 className='ui huge white header'>
                Die, die Köniz regieren wollen, auf dem Prüfstand
                </h1>
                <p className='ta lead'>Welches Verständnis von Führung haben die Kandidaten fürs Könizier Gemeindepräsidium? Und was denken sie über ihre Gegner?
                </p>
              </div>
            </div>

          </div>
        </header>

        <figcaption className='ui container ta caption'>
          Die Gemeinde Köniz im Wahlkampffieber. Nun steht der zweite Wahlgang an. (Bild: Adrian Moser)
        </figcaption>

        <main className=''>

          <section className='ui vertical segment'>
            <div className='ui text container'>
              <p className='ta lead'>
                <div className='ta author'>Von Simon Preisig
                </div>
              </p>
              <p className='ta lead'>
                Das Rennen um das Könizer Gemeindepräsidium bleibt auch im zweiten Wahlgang spannend. Die Bestplatzierte, Annemarie Berlinger-Staub (SP), kann sich ihres Sieges am 22. Oktober nicht sicher sein, denn die SVP unterstützt Hans-Peter Kohler von der FDP. Der dritte Kandidat, Thomas Brönnimann (GLP), tritt zwar als Aussenseiter an. Doch er hat als einziger bisheriger Gemeinderat bereits eine Amtszeit hinter sich. Hilft ihm dieser Bonus? Der «Bund» hat die drei Kandidaten in die Mangel genommen und ihnen Fragen gestellt, um ihre Führungsfähigkeiten zu testen. Denn der zukünftige Könizer Gemeindepräsident ist für über 600 Mitarbeitende verantwortlich und muss mehr als 40 000 Einwohnerinnen und Einwohnern gerecht werden.
              </p>

              <Waypoint scrollableAncestor={window} onEnter={(event) => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    'event': 'startReading',
                    'debug': true
                  }
                  )
                }
              }} />

            </div>
          </section>

          <Waypoint scrollableAncestor={window} onEnter={(event) => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': 'startInterview'
              }
              )
            }
          }} />

          <section className='ui vertical segment'>

            <div className='ui text container'>
              <Question q='Warum sollen die Könizer und Könizerinnen gerade Sie zum Gemeindepräsidenten respektive zur Gemeindepräsidentin wählen?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Ich bin Juristin, habe aber auch ausserhalb des akademischen Umfelds gearbeitet. Dabei hatte ich mit Menschen zu tun, die sich in schwierigen Lebenssituationen befanden. Dies hat mir die Fähigkeit gegeben, auch hinzuschauen, wenn es schwierig ist. Ich halte dem Druck eines Konflikts stand, suche ihn aber nicht. Anzugreifen, nur um Aufmerksamkeit zu erhalten, mag in einem Parlament in Ordnung sein. In einer Exekutive ist es jedoch fehl am Platz.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Ich verstehe die Politik in der Gemeinde, aber auch die im Kanton: Mein Grossratsmandat wird Köniz weiter bringen. Ich leite zurzeit ein Stadtspital. Dies zeigt: Ich kann grössere Betriebe führen. Als Arzt habe ich viel gelernt über Sozialpolitik, aber auch über Finanzpolitik.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ich bringe Exekutiv-Erfahrung aus einer Direktion mit 300 Angestellten mit. Als Schulkommissionspräsident bin ich für noch einmal 500 Lehrerinnen und Lehrer zuständig. Der Präsident der Schulkommission trägt viel Verantwortung, gerade wenn es darum geht, unangenehme Personalentscheide zu treffen. Für Entlassungen ist nämlich die Schulkommission zuständig.
                  </p>
                </Answer>
              </Question>
              <Question q='Und warum keinen Ihrer Gegenkandidaten?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Hans-Peter Kohler bringt fachlich nicht die Voraussetzungen mit, die notwendig sind, um Gemeindepräsident zu werden. Ich bin da als Juristin klar im Vorteil. Und Thomas Brönnimann passt fachlich besser in die Schuldirektion, die er ja bereits heute führt.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Annemarie Berlinger ist viel zu links. Eine so weit links positionierte Gemeindepräsidentin tut der Gemeinde Köniz nicht gut. Und ich bin mir nicht sicher, ob Frau Berlinger die fürs Präsidium benötigte Führungserfahrung mitbringt. Auch Thomas Brönnimann politisiert mir zu grün und ist klar kein Bürgerlicher. Er steht viel weiter links, als er zurzeit vorzugeben versucht.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ob Annemarie Berlinger ungerechtfertigte Kritik so einfach wegstecken kann, wage ich zu bezweifeln. Sie muss dies noch beweisen. Auch Hans-Peter Kohler halte ich für zu wenig kritikfähig. Er betont zwar immer, er habe auf seinem ersten Bildungsweg Radio- und Fernsehelektroniker gelernt. Doch ich erlebe ihn als sehr professoral.
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <div>
            <div className='ui container'>
              {
                /* <div className='videoWrapper'>
                <iframe className='externalNNIFrame' src='https://www.tagesanzeiger.ch/extern/videoplayer/videoplayer-nn.html?params=client@tagesanzeiger|videoId@287020|showLogo@0|autoStart@0|mute@0|showAds@true|previewPath@https://server025.newsnetz.tv/287020/frame-1-287020.jpg|platform@desktop' allowFullScreen='true' scrolling='no' frameBorder='no' />
                </div> */
              }
              <img className='ui fluid image' src={require('./thomas_broennimann_landscape.jpg')} />
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Der einizige «Bisherige»: Gemeinderat Thomas Brönnimann, GLP. (Bild: Franziska Rothenbühler)
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Waypoint scrollableAncestor={window} onEnter={(event) => {
                if (event.previousPosition === 'below') {
                  window.dataLayer = window.dataLayer || []
                  window.dataLayer.push({
                    'event': '50ContentRead'
                  }
                  )
                }
              }} />

              <Question q='Sie wurden im ersten Wahlgang als Könizer Gemeinderat gewählt. Eine gute Leistung. Doch im Leben läuft es nicht immer rund. Was war bisher Ihr grösster Misserfolg?' classes='ui small black header'>
                <Answer who='Annemarie Berlinger'>
                  <p>
                    Als ich 2011 auf der Nationalratsliste der SP-Frauen kandidierte, bin ich auf dem letzten Platz gelandet. Dies, obwohl ich damals einen sehr aktiven Wahlkampf betrieben habe. Ich war sehr enttäuscht und überlegte mir kurz, ganz aus der Politik auszusteigen. Heute bin ich glücklich, es nicht getan zu haben.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                    2010, als die FDP ihr Tief hatte, verpasste ich die Wahl in den Grossen Rat. Ich war enttäuscht über das Abschneiden meiner Partei. Wenn die FDP ihren Wähleranteil hätte halten können, hätte ich es bereits damals in den Grossen Rat geschafft. Beruflich hatte ich wirklich nie einen Misserfolg, ausser vielleicht in der Sekundarschule. Damals war ich ein äusserst schlechter Schüler.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                    Dass in Köniz das linke Grüne Bündnis (GB) und die liberalere Grüne Freie Liste (GFL) fusionierten, ist einer meiner Misserfolge. Ich gehörte damals der GFL an und kämpfte gegen diese Fusion. Ich verlor und war schwer enttäuscht. Wir mussten dann die Grünliberale Partei (GLP) gründen, das hat viel Energie gekostet. Heute hat sich die Abspaltung aus ökologischer Sicht aber gelohnt. Die Grünen stellen 6 Parlamentarier, die GLP deren 4. Grüne Themen haben in Köniz eine grössere Lobby denn je.
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <div className='black-bg'>
            <div className='ui container'>
              <img className='ui fluid image' src={require('./annemarie_berlinger_landscape.jpg')} />
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Annemarie Berlinger auf der Eichmatt im Könizer Ortsteil Schliern. (Bild: Franziska Scheidegger)
          </figcaption>

          <div className='ui text container' style={{position: 'relative'}}>
            <aside className='ui right rail computer or lower hidden'>
              <FeedbackMessage additionalClasses={[]} />
            </aside>
          </div>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Als Gemeindepräsident respektive Gemeindepräsidentin muss man auch einstecken können. Wie reagieren Sie auf ungerechtfertigte Kritik?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Dann will ich vom Kritiker oder der Kritikerin wissen, wie er oder sie zu diesem Schluss gelangt ist. Nachher überlege ich mir, ob die Person einfach so dahergeredet hat oder ob die Sache Hand und Fuss hat.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Mit ungerechtfertigter Kritik muss man als Politiker bis zu einem gewissen Mass leben. Kritik an sich ist ja nichts Schlechtes. Wenn an der Kritik aber wirklich nichts dran ist, dann ignoriere ich sie auch einmal.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ich bin in den letzten Jahren einige Male verbal geprügelt worden, teilweise auch zu unrecht. Solange ich manchmal von links und manchmal von rechts unter Beschuss stehe, kann meine Politik aber nicht so falsch sein. Kritik sollte man in der Regel ernst nehmen, aber wenn sie ungerechtfertigt ist, darf man sie auch einmal abprallen lassen.
                  </p>
                </Answer>
              </Question>
            </div>
          </section>
          <aside className='ui vertical  segment' style={{
            background: '#feebd5',
            color: '#333'
          }}>
            <div className='ui container'>
              <div className='ui relaxed two column stackable grid'>

                <div className='column'>
                  <Profile avatarSrc={require('./annemarie_berlinger.png')}
                    link='https://www.derbund.ch/12617508' name='Annemarie Berlinger (SP)'>
                    Die 44-jährige Juristin arbeitet als wissenschaftliche Mitarbeiterin beim Bundesamt für Sozialversicherungen. Vor ihrer Wahl in die Exekutive sass sie für die SP mehr als 10 Jahren im Könizer Gemeindeparlament, das sie 2012 präsidierte. Im ersten Wahlgang schnitt Berlinger klar am besten ab.<br /><i className='external icon' /> <a href='https://www.derbund.ch/12617508'>Zum Porträt</a></Profile>
                </div>

                <div className='column'>
                  <Profile name='Thomas Brönnimann (GLP)' link='https://www.derbund.ch/22045149' avatarSrc={require('./thomas_broennimann.png')}>
                    Der bisherige Schul- und Sozialvorsteher und Mitbegründer der Grünliberalen in Köniz ist der einzige Gemeinderat, dessen Wiederwahl nicht von der Amtszeitbeschränkung verhindert worden war. Neben dem Amt in der Gemeinde sitzt der 49-Jährige seit 2010 auch im Grossen Rat.<br /><i className='external icon' /> <a href='https://www.derbund.ch/22045149'>Zum Porträt</a> </Profile>
                </div>
                <div className='column'>
                  <Profile avatarSrc={require('./hans-peter_kohler.png')}
                    link='https://www.derbund.ch/19326467' name='Hans-Peter Kohler (FDP)'>
                    Der 57-jährige gelernte Radio- und Fernseh-Elektriker und studierte Mediziner ist leitender Arzt im Tiefenauspital. Seit drei Jahren ist Kohler Grossrat, vor seiner Wahl in den Gemeinderat war er zwölf Jahre Parlamentarier in Köniz.<br /><i className='external icon' /> <a href='https://www.derbund.ch/19326467'>Zum Porträt</a> </Profile>
                </div>

              </div>
            </div>
          </aside>
          <section className='ui vertical segment'>
            <div className='ui text container'>
              <Question q='Welche ausserordentlichen Erfolge qualifizieren Sie für diesen Job?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Meine politischen Erfolge sind das umgesetzte Könizer Bauzonenmoratorium. Und die Mietzinsreduktionen bei der Sozialhilfe: Die wegen des sinkenden Referenzzinssatzes möglichen Anpassungen lassen Köniz sparen, ohne dass es den Ärmsten wehtut. Ich habe ein Studium auf dem zweiten Bildungsweg erfolgreich abgeschlossen. In der gleichen Zeit sind auch meine Kinder zur Welt gekommen. Ich bin es also gewohnt, unter hoher Auslastung zu arbeiten.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Ich denke, mein Bildungsweg qualifiziert mich. Ich habe vor meinem Studium als Arzt mit Radio- und Fernsehelektronik ein richtiges Handwerk gelernt. In meiner Lehre realisierte ich, dass man, wenn man will, auch als einst schlechter Schüler noch eine Matur und dann ein Studium absolvieren kann.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Unter mir als Schulvorsteher wurde die Sanierung der Könizer Schulhäuser angepackt. Die Erweiterung der Tagesschule im Spiegel wurde in nur wenigen Jahren geplant und umgesetzt, das Schulhaus Buchsee wurde aufgestockt. Ich konnte dies nicht allein tun, die anderen Mitglieder des Gemeinderats haben mitgeholfen.
                  </p>
                </Answer>
              </Question>
              <Question q='Beim abtretenden Gemeinderat beschleicht einen das Gefühl, jeder und jede koche sein eigenes Süppchen und man rede sich nur wenig drein. Würde sich das unter Ihnen ändern?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Da muss man etwas ändern, das Gärtchendenken war zu stark ausgeprägt. Es gibt heute zu viele Themen, bei denen die Zuständigkeiten quer über die Direktionen verteilt sind. Konkret habe ich dies bei meinem Vorstoss zum alten Schulhaus Schliern erlebt. Das Geschäft wurde vom einen Gemeinderat zum nächsten weitergereicht. Ich werde für solche Themen Projektgruppen ins Leben rufen, bei denen die Kompetenzen bereits im Vorfeld klar geregelt werden.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Es ist schwierig zu sagen, wie mein persönliches Verhältnis mit den einzelnen Gemeinderäten sein wird. Aber grundsätzlich stehen die Interessen von Köniz an erster Stelle. Die Partikularinteressen sollen so gross sein, wie sie müssen, um die Direktionen führen zu können. Das heisst aber, dass wir als Kollegialbehörde auch mal einem unserer Mitglieder dreinreden müssen.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Der Könizer Gemeinderat hat in den letzten vier Jahren gut funktioniert. Es ist jedoch nicht von der Hand zu weisen, dass jeder Gemeinderat eine bestimmte politische Ausrichtung hat und deswegen bei bestimmten Themen nicht offen für die Vorschläge seiner Kollegen ist. Darum werde ich dem neuen Gemeinderat vorschlagen, ein Rotationsprinzip einzuführen. Wir würden unsere Direktionen jedes Jahr wechseln. So könnten wir zu einem unabhängigen, strategischen Gremium werden und viele Entscheide gemeinsam treffen.
                  </p>
                </Answer>
              </Question>

            </div>
          </section>

          <Waypoint scrollableAncestor={window} onEnter={(event) => {
            if (event.previousPosition === 'below') {
              window.dataLayer = window.dataLayer || []
              window.dataLayer.push({
                'event': '75ContentRead'
              }
              )
            }
          }} />

          <div className='black-bg'>
            <div className='ui container'>
              <img className='ui fluid image' src={require('./hans-peter_kohler_landscape.jpg')} />
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Hans-Peter Kohler: Vom Radio- und TV-Elektriker zum leitenden Arzt. (Bild: Franziska Rothenbühler)
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Wenn Sie gewählt werden, stehen Sie einer Gemeinde mit mehr als 40 000 Einwohnern vor. Was sind Sie für eine Führungsperson?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Ich sehe es als meine Hauptaufgabe zu gewährleisten, dass alle Angestellten möglichst gut arbeiten können. Dass die richtigen Leute am richtigen Ort sind, ist dabei die wichtigste Voraussetzung. Zudem erteile ich klare Aufträge. Für mich liegt die grösste Herausforderung darin, die Balance zu finden zwischen dem Vertrauen in die Menschen und dem Erkennen des richtigen Augenblicks, wenn ich bei Schwierigkeiten eingreifen muss.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Für mich ist immer wichtig, dass für eine Entscheidung die Fakten wirklich auf dem Tisch sind. Dann braucht es aber auch einmal harte Beschlüsse. Ich werde von meinen Gemeinderatskollegen verlangen, dass sie die dafür notwendigen Informationen bei ihren Direktionen einfordern. Den Umgangston wähle ich dabei kollegial und die Sitzungen leite ich strukturiert.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ich führe kooperativ, kollegial und mit klaren Vorstellungen davon, was ich erreichen will. In der Schulkommission, wo ich ja das Präsidium innehabe, revidierten wir die Geschäftsordnung. Nun habe ich zwei Vizepräsidien, die den zwei grössten Parteien (SP und SVP) angehören. Wir wechseln uns in der Sitzungsleitung jeweils ab.
                  </p>
                </Answer>
              </Question>

              <Question q='Und welche speziellen Herausforderungen sehen Sie bezogen auf die Leitung der Gemeinde Köniz?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Hier gilt es vor allem, keine Gräben herbeizureden. Es liegt auf der Hand, dass die ländlichen Ortsteile andere politische Schwerpunkte setzen als die urbanen Teile von Köniz. Wenn wir uns auch weiterhin dieser Unterschiede bewusst sind und alle bei der Lösungssuche einbeziehen, bleibt Köniz so vielfältig, wie es heute ist.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Der Gemeinderat ist ein Kollegium, wie ich auch im Stadtspital Tiefenau eines führe. Der grosse Unterschied ist jedoch, dass die einzelnen Direktionen nicht von Fachpersonen, sondern von Politikern geleitet werden. Ich würde als Präsident darauf schauen, dass die Gemeinderäte diesen Rückstand raschmöglichst mit Hilfe ihres qualifizierten Gemeindepersonals zumindest zu einem gewissen Teil aufholen müssten.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ich würde nicht wie Ueli Studer immer oben am Tisch sitzen. Im Zimmer des Gemeinderats gilt nämlich eine strenge Hierarchie. Oben hockt der Präsident, links davon die Vizepräsidentin und rechts die amtsälteste Gemeinderätin. Dies finde ich nicht mehr zeitgemäss. Ich würde auch die Legislaturziele anders erarbeiten, als wir es vor vier Jahren getan haben. Damals haben wir als Gemeinderat die Ziele anhand unserer politischen Ausrichtung bestimmt. Heute würde ich mehr auf die Basis hören, also auch die Fachkader einbeziehen.
                  </p>
                </Answer>
              </Question>

              <Question q='Wie viel ist es Ihnen wert, gewählt zu werden? Oder besser gefragt: Wie viel hat Ihre Wahlkampagne gekostet?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Die SP hatte ein Budget in der Gesamthöhe von 80'000 Franken. Ich persönlich habe 5000 Franken beigesteuert und 10 000 Franken an Spenden erhalten, die ich an die Partei weiterleitete.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Ob es jemanden interessiert, wie viel ich und meine Partei für den Wahlkampf ausgegeben haben, wage ich zu bezweifeln. Zurzeit habe ich sowieso noch keine Übersicht über die Ausgaben. Ob wir das Budget allenfalls nach dem zweiten Wahlgang offenlegen, muss ich mit der Parteileitung besprechen.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Die GLP hatte ein Wahlbudget von ungefähr 63'000 Franken, davon habe ich ungefähr 37'000 Franken aus eigenen Mitteln beigesteuert. Wir konnten leider nicht auf viele Spenden setzen. Dies ist wohl der Preis für eine unabhängige Politik.
                  </p>
                </Answer>
              </Question>
              <Question q='Es gibt Stimmen in der Region Bern, die fordern, dass sich die Agglomerationsgemeinden mit der Stadt zusammenschliessen. Sähen Sie in einer Fusion eine Chance?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Es braucht klar mehr Zusammenarbeit. Und hier spreche ich nicht von den kommenden vier Jahren, sondern von den nächsten Jahrzehnten. Die rasch voranschreitende Globalisierung macht vor Gemeindegrenzen keinen Halt. Ich glaube nicht, dass wir in den gleichen Strukturen, die wir in den letzten 100 Jahren hatten, auch in den kommenden 100 Jahren weiterfunktionieren können. Und ja, da würde auch eine Fusion zum Thema.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Mir passen die Gespräche nicht, in denen es um ein neues Grossbern geht. Über eine Fusion mag ich gar nicht reden. Es gibt aber sicher einzelne Bereiche, wo wir mit Bern vertieft zusammenarbeiten könnten. Welche, kann ich jetzt auf die Schnelle nicht sagen.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Tendenziell soll Köniz enger mit Bern zusammenarbeiten, jedoch sicher nicht fusionieren. Köniz zählt genügend Einwohner, wir funktionieren besser ohne Bern. Gerade unsere Bildungslandschaft ist eine vielfältigere als jene in der Stadt Bern. Im Sportbereich hingegen könnten wir noch vertiefter kooperieren. Warum neben der Ballsporthalle Weissenstein nicht auch noch ein gemeinsames Rasenfeld bauen?
                  </p>
                </Answer>
              </Question>
            </div>
          </section>

          <div className='black-bg'>
            <div className='ui container'>
              <img className='ui fluid image' src={require('./urban.jpg')} />
            </div>
          </div>

          <figcaption className='ui container ta caption'>
                Der neue Präsident oder die neue Präsidentin regiert künftig sehr städtische Ortsteile. Im Bild der Liebefeld Park. Foto: Franziska Rothenbühler
          </figcaption>

          <section className='ui vertical segment'>
            <div className='ui text container'>

              <Question q='Die finanzielle Lage von Köniz ist angespannt. Der Investitionsbedarf ist hoch, die Schulden ebenfalls. Heben Sie als Gemeindepräsident respektive Gemeindepräsidentin die Steuern an?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Ja, sonst steigt die Verschuldung unserer Gemeinde weiter an.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Nein, eine Steuererhöhung ist nicht nötig. Ich sehe immer noch keinen Grund, warum man die Steuern unbedingt erhöhen soll. Dies ist nur der einfachste Weg, um zu Geld zu kommen.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ja, ich stehe hinter der Steuerstrategie des noch amtierenden Gemeinderats. Ich weiss, mein Gegenkandidat Hans-Peter Kohler glaubt, beim Personal noch sparen zu können. Doch ich weiss: Auf der Gemeindeverwaltung dreht niemand Däumchen. Im Gegenteil: Wegen des Bevölkerungswachstums betreut heute jeder Angestellte mehr Einwohner und Einwohnerinnen als noch vor einigen Jahren.
                  </p>
                </Answer>
              </Question>

              <Question q='Die Machtverhältnisse im Parlament lassen vermuten, dass dem Volk sowieso eine Steuererhöhung vorgelegt wird. Sie wären dafür zuständig, diese zu vertreten. Wie tun sie das?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Die Steuererhöhung muss man gut erklären und aufzeigen, was passiert, wenn wir die Steuern nicht erhöhen. Von den flankierenden Massnahmen, also der zweckgebundenen oder der temporären Steuererhöhung, halte ich nicht viel. Was die GLP und die SVP da fordern, darf die Bevölkerung sowieso vom Gemeinderat erwarten, das ist Ehrensache.  Die Steuern müssen sinken, wenn die finanzielle Situation dies zulässt.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Ich setze mich dafür ein, dass keine Steuererhöhung nötig wird. Wenn es doch so weit kommt, werde ich erklären, warum die Mehrheit der Kollegialbehörde Gemeinderat eine Steuererhöhung will. Es wäre dann an meiner Partei, vor dem Urnengang gegen diese Steuererhöhung zu kämpfen. Klar, der Wechsel in die Exekutive ist ein Rollenwechsel, aber man erhält keine Gehirnwäsche. Die Könizer wüssten nach wie vor, dass ich keine Steuererhöhung will.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Der amtierende Gemeinderat hat dieses und letztes Jahr noch einmal ein Sparpaket geschnürt. So wurden die Badi-Eintritte teurer, und die Strompreise sind gestiegen. In vielen Bereichen ist nun die Schmerzgrenze erreicht. Ich denke, das sieht die Bevölkerung ähnlich, dies könnte ich auch glaubhaft aufzeigen. Zudem würde ich, wenn vom Parlament gewünscht, die Steuern nur temporär erhöhen oder das Geld für einen bestimmten Zweck reservieren.
                  </p>
                </Answer>
              </Question>

              <Question q='Sie werden auch die Könizer Kulturpolitik verantworten. Geben Sie der Heiteren Fahne Geld? Im Gegenzug könnten Sie ja dem Berner Stadttheater die Mittel kürzen.' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Die Heitere Fahne ist für mich eine Institution, die Unterstützung verdient, jedoch nicht die einzige. Wir sollten mit einer neuen Kulturstrategie festlegen, was wir fördern wollen. In der Vergangenheit wurde bei der Kultur gespart, auch weil der Gemeinderat nicht wusste, wo er hinwill. Für die lokale Kultur sehe ich viel Potenzial. Auch der Beitrag an die regional bedeutenden Kulturinstitutionen, darunter auch das Berner Stadttheater, sollte nicht verändert werden.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Das Stadttheater soll nach wie vor unterstützt werden. Zur Heiteren Fahne: Ich spreche mich heute gegen eine Unterstützung aus. Die Heitere Fahne zählt 30 000 Besucher pro Jahr. Zahlen diese Leute nichts für ihren Besuch, frage ich mich. Doch mein Nein ist nicht definitiv. Wir müssen analysieren, wo der Steuerfranken hingeht. Und wenn wirklich viele Leute die Heitere Fahne besuchen, dann sollten wir vielleicht bei einer andern Institution sparen.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Die Verträge mit dem Berner Stadttheater über die Regionalkonferenz sind bindend und deswegen nicht diskutabel. Mehr Geld als heute sollte aber nicht nach Bern fliessen. Einen Leistungsvertrag mit der Heiteren Fahne fände ich sinnvoll, ungefähr 30 000 Franken sollte die Institution, die viel leistet, jährlich erhalten. Der Beitrag an die Betriebskosten würde es für die Heitere Fahne einfacher machen, projektbezogene Beiträge zu akquirieren.
                  </p>
                </Answer>
              </Question>
              <Question q='War es richtig, dass der noch amtierende Gemeinderat dem Kinderbuchfestival (Kibuk) die Unterstützung entzogen hat und der Anlass deswegen nicht mehr stattfindet?' classes='ui small black header'>

                <Answer who='Annemarie Berlinger'>
                  <p>
                  Nein, das Kinderbuchfestival einfach zu streichen, war falsch. Ich war von Beginn weg als Gast und später auch als Helferin bei diesem Event dabei. Es wurde immer ein buntes Programm geboten, das schweizweit einzigartig war. Dass der Anlass künftig von jemand anderem als der Kulturabteilung organisiert werden müsste, kann ich verstehen. Dies ist nicht die Aufgabe der Gemeinde. Aber man hat viel zu schnell aufgegeben, eine andere Trägerschaft für diesen Anlass zu finden.
                  </p>
                </Answer>

                <Answer who='Hans-Peter Kohler'>
                  <p>
                  Dies hat der Gemeinderat so beschlossen. Ich kann da nicht viel mehr dazu sagen, da ich mich nicht intensiv mit diesem Thema beschäftigt habe. Grundsätzlich finde ich es sinnvoll, ständig zu überprüfen, wem man wie viel Geld gibt.
                  </p>
                </Answer>

                <Answer who='Thomas Brönnimann'>
                  <p>
                  Ja, dies ist richtig. Das Festival hat sein ursprüngliches Ziel, die überregionale Ausstrahlung, leider nie erreicht. Zudem haben auch nur wenige Leute das Festival besucht. Das Budget war im Verhältnis zur Wirkung riesig. Es hat die Kulturabteilung zudem viel Zeit gekostet, dieses Festival zu organisieren. Das Kibuk war ein Versuch, aber es war auch Zeit, zu akzeptieren, dass der Versuch gescheitert ist.
                  </p>
                </Answer>
              </Question>

            </div>

            <Waypoint scrollableAncestor={window} onEnter={(event) => {
              if (event.previousPosition === 'below') {
                window.dataLayer = window.dataLayer || []
                window.dataLayer.push({
                  'event': 'endInterview'
                }
                )
              }
            }} />

            <aside className='ui vertical segment white-bg'>
              <div className='ui container'>
                <div className='ui image'>
                  <img src={require('./landschaft.jpg')} />
                </div>
                <figcaption className='ta caption'>
                Die zum gewählte Person, ist auch für die ländlichen Ortsteile von Köniz zuständig. Ein zu grosser Spagat? Im Bild ein Feld bei Mengenstorf. (Foto: Franziska Rothenbühler)
                </figcaption>
              </div>
            </aside>

          </section>

        </main>

        <Waypoint scrollableAncestor={window}
          onEnter={(event) => {
            if (event.previousPosition ===
          'below') {
              window.dataLayer =
            window.dataLayer || []
              window.dataLayer.push({
                'event': 'contentBottom'
              }
              )
            }
          }} />

        <div className='ui vertical inverted infographic segment'>
          <div className='ui container'>
            <div className='ui stackable two column aligned grid'>
              <div className='column'>
                <table className='ui definition inverted very basic table'>
                  <tbody>
                    <tr>
                      <td>Digitales Konzept</td>
                      <td>Mathias Lutz</td>
                    </tr>
                    <tr>
                      <td>Umsetzung: </td>
                      <td>Christian Zellweger, Simon Preisig</td>
                    </tr>
                    <tr>
                      <td>Fotos:</td>
                      <td>Adrian Moser, Franziska Rothenbühler, Franziska Scheidegger</td>
                    </tr>
                    <tr className='desktop-only'>
                      <td colSpan='2'><CopyrightNotice inverted /></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className='column'>

                <table className='ui definition inverted very basic table'>
                  <tbody>
                    <tr>
                      <td><i className='comments icon' /></td>
                      <td>
                        <div className='content'>
                          <div className='header'> Haben Sie Anmerkungen oder
                          einen Fehler entdeckt?
                          </div>
                          <p>
                            <span>Wir freuen uns über Ihre </span>
                            <a href='mailto:bern@derbund.ch?subject=Assessment in Köniz'>Nachricht</a>
                            <span>.</span>
                          </p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan='2' className='footer-sharing'>
                        <div className='spacer'>&nbsp;</div>
                        <StandaloneShareButtons articleID='27362773' />
                        <Tracking articleId='27362773' />

                        <Waypoint scrollableAncestor={window}
                          onEnter={(event) => {
                            if (event.previousPosition ===
                                                       'below') {
                              window.dataLayer =
                                                      window.dataLayer || []
                              window.dataLayer.push({
                                'event': 'pageBottom'
                              }
                              )
                            }
                          }} />
                        <div className='spacer'>&nbsp;</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>

      </div>
    )
  }
}

AppComponent.defaultProps = {}



// WEBPACK FOOTER //
// ./src/components/main/Main.js